<template>
  <div v-if="profile" class="gp-container">
    <div class="tile is-ancestor dashboard-container">
      <div class="tile is-parent">
        <tile-basic
          class="is-info"
          :values="keyValues(profile)"
          img="profile"
          title="Profile Info">
        </tile-basic>
      </div>
      <div class="tile is-parent">
        <tile-basic
          class="is-info"
          title="Profile Analytics">
          <chart-analytics-pie
            v-if="profile.analytics.length > 0"
            slot="top"
            :analytics="profile.analytics">
          </chart-analytics-pie>
        </tile-basic>
      </div>
    </div>
  </div>
</template>

<script>
import profiles from '@/mixins/profiles';
import TileBasic from '@/components/TileBasic.vue';
import ChartAnalyticsPie from '@/components/charts/ChartAnalyticsPie.vue';

export default {
  name: 'ProfileDetails',
  mixins: [profiles],
  components: {
    TileBasic,
    ChartAnalyticsPie,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  computed: {
    profileValues() {
      return [
        {
          label: 'Name',
          value: this.profile.name,
        },
        {
          label: 'Description',
          value: this.profile.description,
        },
        {
          label: 'Sync Interval',
          value: this.$options.filters.secondsToString(this.profile.infoSyncInterval),
        },
        {
          label: 'Actions Config',
          value: this.profile.actionConfigs.name,
        },
        {
          label: 'Created',
          value: this.$options.filters.formatEpochDate(this.profile.created, this.gmt),
        },
        {
          label: 'Modified',
          value: this.$options.filters.formatEpochDate(this.profile.updated, this.gmt),
        },
        {
          label: 'Hash',
          value: this.profile.hash,
        },
      ];
    },
  },
  data() {
    return {
      categoryFilter: [],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
